import MortandadModal from "./MortandadModal";
export default MortandadModal;